/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export interface Activity {
  activityId: string;
  accountNumber: string;
  activityType: ActivityType;
  status: ActivityStatus;
  dueDate: string;
  originalDueDate: string;
  scheduleDate: string;
  owner: string;
  ownerId: string;
  createdBy: string;
  contactId: string;
  subject: string;
  sourceType: string | null;
  description: string | null;
  from: string | null;
  to: string | null;
  toType: ActivityToType | null;
  duration: number | null;
  location: string | null;
}

export interface ContactPerson {
  contactId: string;
  firstName: string;
  lastName: string;
  phoneNumber: number;
  email: string;
  isPrimaryContact: boolean;
  status: ContactPersonStatus;
}

export enum ContactPersonStatus {
  Active = 1,
  Inactive = 2,
}

export interface Campaign {
  accountNumber: string;
  activityStatus: ActivityStatus;
  activityType: number;
  actualEnd: string;
  actualStart: string;
  campaignActivityId: string;
  campaignCode: string;
  campaignId: string;
  campaignName: string;
  competitorId: string | null;
  competitorName: string | null;
  description: string;
  linkToSharePoint: string;
  proposedEnd: string | null;
  proposedStart: string | null;
  responseCode: number;
  responseCodeName: string | null;
  responseDescription: string | null;
  responseReason: string | null;
  responseType: string | null;
  subject: string;
}

export interface ActivitiesResponse {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  activities: Activity[];
  contactPersons: ContactPerson[];
  campaigns?: Campaign[];
}

export interface LookupValue {
  label: string;
  value?: number;
  id?: string;
  parentValues?: number[];
}

export interface Lookup {
  name: string;
  values: LookupValue[];
  parentLookup?: string;
}

export interface Competitor {
  label: string;
  id: string;
}

export interface LookupsResponse {
  lookups: Lookup[];
}

export enum ActivityType {
  Phone = 4210,
  Appointment = 4201,
  Letter = 4207,
  Fax = 4204,
  Email = 4202,
}

export enum ActivityStatus {
  Open = 0,
  Completed = 1,
  Canceled = 2,
  Scheduled = 3,
}

export enum ActivityToType {
  Account = 'account',
  Contact = 'contact',
}

export enum ResponseCode {
  Won = 1,
  Lost = 2,
  ToBeConfirmed = 3,
  NotRequired = 4,
}

export interface CreateOrUpdateActivityPayload {
  activityId?: string;
  activityType: number;
  accountNumber: string;
  status: number;
  dueDate?: string | null;
  scheduleDate: string;
  contactId: string;
  subject: string;
  description?: string | null;
  to?: string | null;
  toType?: ActivityToType | null;
  duration?: number | null;
  campaignResponses?: CampaignActivity[];
  originalDueDate?: string;
  from?: string | null;
  location?: string | null;
  owner?: string;
  sourceType?: string | null;
}

export interface CampaignActivity {
  accountNumber: string;
  campaignActivityId?: string;
  campaignName: string;
  campaignCode: string;
  campaignId: string;
  activityType: ActivityType;
  activityStatus: ActivityStatus;
  subject: string;
  proposedStart?: string;
  proposedEnd?: string;
  actualStart?: string;
  actualEnd?: string;
  linkToSharePoint: string;
  description: string;
  responseCode?: number;
  responseCodeName?: string;
  responseType?: number;
  responseReason?: number;
  competitorName?: string;
  competitorId?: string;
  responseDescription?: string;
}
